import axios from "axios";

/* ==========================================================
   AXIOS INSTANCE (SINGLE SOURCE OF TRUTH)
========================================================== */
const API = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/* ==========================================================
   REQUEST INTERCEPTOR (AUTH TOKEN)
========================================================== */
API.interceptors.request.use(
  (config) => {
    const authData = localStorage.getItem("auth");
    if (authData) {
      try {
        const { token } = JSON.parse(authData);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error("Invalid auth data in localStorage");
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* ==========================================================
   RESPONSE INTERCEPTOR (DEBUGGING)
========================================================== */
API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API ERROR:", {
      url: error.config?.baseURL + error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      data: error.response?.data,
    });
    return Promise.reject(error);
  }
);

/* ==========================================================
   USER APIs
========================================================== */
export const registerUser = (data) =>
  API.post("/api/user/register", data);

export const loginUserPassword = (data) =>
  API.post("/api/user/login/password", data);

export const usersendOtp = (data) =>
  API.post("/api/user/login/otp/send", data);

export const userverifyOtp = (data) =>
  API.post("/api/user/login/otp/verify", data);

export const getUserProfile = () =>
  API.get("/api/user/profile");

export const userplatformFees = (data) =>
  API.post("/api/platform-fee/pay", data);

export const userWallet = () =>
  API.get("/api/platform-fee/wallet");

/* ==========================================================
   PUROHIT AUTH APIs
========================================================== */
export const registerPurohit = (data) =>
  API.post("/purohit/auth/register", data);

export const loginPurohitPassword = (data) =>
  API.post("/purohit/login/password", data);

export const purohitsendOtp = (data) =>
  API.post("/purohit/login/otp/send", data);

export const purohitverifyOtp = (data) =>
  API.post("/purohit/login/otp/verify", data);

export const getPurohitProfile = () =>
  API.get("/purohit/auth/profile");

export const purohitUnlock = () =>
  API.get("/unlock/my-unlocks");

export const unlockId = (purohitId) =>
  API.post(`/unlock/${purohitId}`);

/* ==========================================================
   TEMPLE AUTH APIs
========================================================== */
export const registerTemple = (data) =>
  API.post("/temple/register", data);

export const loginTemplepassword = (data) =>
  API.post("/temple/login/password", data);

export const templesendOtp = (data) =>
  API.post("/temple/login/otp/send", data);

export const templeverifyOtp = (data) =>
  API.post("/temple/login/otp/verify", data);

/* ==========================================================
   PASSWORD RESET APIs
========================================================== */
export const sendOtp = (data) =>
  API.post("/forgot-password/send-otp", data);

export const verifyOtp = (data) =>
  API.post("/forgot-password/verify-otp", data);

export const resetPassword = (data) =>
  API.post("/forgot-password/reset-password", data);

/* ==========================================================
   PUROHIT PROFILE APIs
========================================================== */
export const updatePurohitProfile = (data) =>
  API.put("/purohit/profile/complete", data);

export const getAllPurohitProfiles = () =>
  API.get("/user/purohits");

/* ==========================================================
   PUROHIT SUBSCRIPTION APIs
========================================================== */
export const purohitSubscriptionYearly = (data) =>
  API.post("/purohit/subscription/yearly", data);



/* ==========================================================
   DASHBOARD API
========================================================== */
export const getPurohitDashboard = () =>
  API.get("/purohit/dashboard");

export default API;
